export enum STEPS {
  FLIGHT = "FLIGHT",
  CAR = "CAR",
  PUBLIC_TRANSPORT = "PUBLIC_TRANSPORT",
  MOTORBIKE = "MOTORBIKE",
}